import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/tc',
  component: layout,
  meta: {
    funcID: 'F0010',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'scmOrder',
      name: `${pre}scmOrder`,
      meta: {
        ...meta,
        head: { back: false },
        title: '执行工厂订单',
        funcID: 'F001001',
        PID: 'F00',
      },
      component: () => import('@/views/factory/tc/scmOrder'),
    },
    {
      path: 'scmOrder/:pageType/:code?',
      name: `${pre}scmOrder-detail`,
      meta: {
        ...meta,
        head: { back: true },
        title: ({ $route }) => {
          const { tcOrderNo = '' } = $route.query || {}
          return tcOrderNo || '执行工厂订单'
        },
        funcID: 'F001001',
        PID: 'F00',
      },
      component: () => import('@/views/factory/tc/scmOrder/detail'),
    },
    {
      path: 'fabricOrder',
      name: `${pre}fabricOrder`,
      meta: {
        ...meta,
        head: { back: false },
        title: 'TC面料采购单',
        funcID: 'F001002',
        PID: 'F00',
      },
      component: () => import('@/views/factory/tc/fabricOrder'),
    },
    {
      path: 'fabricOrder/:pageType/:code?',
      name: `${pre}fabricOrder-detail`,
      meta: {
        ...meta,
        head: { back: true },
        title: ({ $route }) => {
          const { tcFabricPurchaseNo = '' } = $route.query || {}
          return tcFabricPurchaseNo || 'TC面料采购单'
        },
        funcID: 'F001002',
        PID: 'F00',
      },
      component: () => import('@/views/factory/tc/fabricOrder/detail'),
    },
    {
      path: 'fabricSell',
      name: `${pre}fabricSell`,
      meta: {
        ...meta,
        head: { back: false },
        title: 'TC面料销售单',
        funcID: 'F001003',
        PID: 'F00',
      },
      component: () => import('@/views/factory/tc/fabricSell'),
    },
    {
      path: 'fabricSell/:pageType/:code?',
      name: `${pre}fabricSell-detail`,
      meta: {
        ...meta,
        head: { back: true },
        title: ({ $route }) => {
          const { tcFabricSalesNo = '' } = $route.query || {}
          return tcFabricSalesNo || 'TC面料销售单'
        },
        funcID: 'F001003',
        PID: 'F00',
      },
      component: () => import('@/views/factory/tc/fabricSell/detail'),
    },
    {
      path: 'tcExpense',
      name: `${pre}expense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001004',
        PID: 'F00'
      },
      component: () => import('@/views/factory/tc/expense')
    },
    {
      path: 'tcExpense/:pageType/:code?',
      name: `${pre}expense-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { tcExpenseNo = '' } = $route.query || {}
          return tcExpenseNo || 'TC采购请款单'
        },
        funcID: 'F001004',
        PID: 'F00'
      },
      component: () => import('@/views/factory/tc/expense/detail')
    },
  ])('tc-'),
}
